import {FunctionComponent, HTMLAttributes, LabelHTMLAttributes} from 'react';
import clsx from 'clsx';
import {twMerge} from 'tailwind-merge';
import {useFormControlContext} from '@/components/form/form-control/form-control';

type LabelProps = {
  multiline?: boolean;
} & (
  | ({inFieldset: true} & HTMLAttributes<HTMLLegendElement>)
  | ({inFieldset?: false} & LabelHTMLAttributes<HTMLLabelElement>)
);

const LabelComponent = (props: LabelProps) => {
  if (props.inFieldset) {
    const {inFieldset, ...rest} = props;
    return <legend {...rest} />;
  } else {
    const {inFieldset, htmlFor, ...rest} = props;
    return <label htmlFor={htmlFor} {...rest} />;
  }
};

const Label: FunctionComponent<LabelProps> = ({children, multiline, ...props}) => {
  const {isRequired, isDisabled} = useFormControlContext();
  const isChildrenEmpty = children && children.toString().trim().length === 0;

  const mergedClasses = clsx(
    'mb-2 block cursor-pointer text-start text-sm font-medium text-charcoal',
    isDisabled && 'text-grey-400',
    !multiline && 'truncate',
  );

  const title = !multiline && typeof children === 'string' ? children : undefined;

  return (
    <LabelComponent className={twMerge(mergedClasses)} title={title} {...props}>
      {typeof children === 'string' ? <span dangerouslySetInnerHTML={{__html: children}} /> : children}
      {/* eslint-disable-next-line i18next/no-literal-string */}
      {!isChildrenEmpty && isRequired && <sup className="text-red">*</sup>}
    </LabelComponent>
  );
};

export default Label;
